<div class="dup-analysis">

  <div class="dup-analysis__header">
    <h5 class="dup-analysis__title mb-1">Attenzione</h5>
    <p class="dup-analysis__subtitle mb-0">
      Alcune domande non possono essere copiate, si prega di ricontrollare le sezioni del nuovo trattamento
    </p>
  </div>

  <div class="dup-analysis__body">

    <div ngbAccordion [closeOthers]="true" class="dup-analysis__accordion">

      <div
        ngbAccordionItem
        *ngFor="let chapter of chapters; let first = first; trackBy: trackByChapter"
        [collapsed]="!first"
        class="dup-analysis__acc-item"
      >
        <h2 ngbAccordionHeader class="dup-analysis__acc-header">
          <button ngbAccordionButton type="button">
            <span class="dup-analysis__acc-title">{{ chapter.chapterName }}</span>
<!--            <span class="dup-analysis__count">{{ chapter.items.length }}</span>-->
          </button>
        </h2>

        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <ng-template>

              <div class="dup-analysis__group">
                <div class="dup-card" *ngFor="let item of chapter.items; trackBy: trackByItem">
                  <div class="dup-card__meta">

                    <div class="dup-card__row">
                      <span class="dup-card__label">Sezione</span>
                      <span class="dup-card__value">
                        {{ item.groupName }}
                        <span class="dup-card__id" *ngIf="developerModeService.debugModeEnabled()">#{{ item.groupId }}</span>
                      </span>
                    </div>

                    <div class="dup-card__row">
                      <span class="dup-card__label">Domanda</span>
                      <span class="dup-card__value">
                        {{ item.widgetName }}
                        <span class="dup-card__id"
                              *ngIf="developerModeService.debugModeEnabled()"
                        >#{{ item.widgetInternalId }}</span>
                      </span>
                    </div>

                    <div class="dup-card__row" *ngIf="developerModeService.debugModeEnabled()">
                      <span class="dup-card__label">Tipo</span>
                      <span class="dup-card__value">
                        <span class="dup-card__type">{{ item.widgetType }}</span>
                      </span>
                    </div>

                    <div class="dup-card__row dup-card__reason">
                      <span class="dup-card__label">Motivo</span>
                      <span class="dup-card__value">{{ item.reason }}</span>
                    </div>

                  </div>
                </div>
              </div>

            </ng-template>
          </div>
        </div>
      </div>

    </div>

    <div *ngIf="!skippedItems?.length" class="dup-analysis__empty">
      Tutte le domande potranno essere copiate.
    </div>

  </div>
</div>
